import { render, staticRenderFns } from "./productHyperElements.vue?vue&type=template&id=fd45cabe"
import script from "./productHyperElements.vue?vue&type=script&lang=js"
export * from "./productHyperElements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Availability: require('/root/containers/hermes_eshop/components/core/availability.vue').default,Rating: require('/root/containers/hermes_eshop/components/core/rating.vue').default})
